module.exports = __webpack_public_path__ + "static/media/icono_calendario.93a41786.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/icono_calendario.png
// module id = 814
// module chunks = 0